import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookmarkIcon, CalendarCheckIcon, LayoutGridIcon, MessageSquareIcon, PackageIcon } from 'lucide-react';
import { marketCategories } from '../../data/market';
import { CATEGORY_ICONS } from './CategoryCard';
import { cn } from '../../utils/cn';
const ACTIVITY = [{
  label: 'Orders',
  to: '/marketplace',
  icon: PackageIcon
}, {
  label: 'Bookings',
  to: '/marketplace',
  icon: CalendarCheckIcon
}, {
  label: 'Messages',
  to: '/community',
  icon: MessageSquareIcon
}, {
  label: 'Saved',
  to: '/marketplace',
  icon: BookmarkIcon
}];

/**
 * The marketplace's own navigation. It sits inside the marketplace rather than
 * in the platform shell, because these destinations only mean anything here —
 * and it keeps the nine categories one click apart from every subpage.
 */
export function MarketRail() {
  const {
    pathname
  } = useLocation();
  const item = (active: boolean) => cn('flex min-h-touch items-center gap-3 rounded-lg px-3 text-body-sm transition-colors duration-150 ease-out', active ? 'bg-brand-50 font-semibold text-brand-800' : 'font-medium text-ink-muted hover:bg-canvas hover:text-ink');
  return <nav aria-label="Marketplace" className="space-y-6" data-id="element-2886" data-mp="2say1i474pp1j">
      <div data-id="element-2887" data-mp="2o8b4lovlpdxh">
        <p className="px-3 text-caption font-semibold uppercase tracking-wide text-ink-subtle" data-id="element-2888" data-mp="2o8t7h4crqqed">
          Marketplace
        </p>
        <ul className="mt-2 space-y-0.5" data-id="element-2889" data-mp="3kx8y73rm75t2">
          <li data-id="element-2890" data-mp="3l0emigsf63nq">
            <Link to="/market" className={item(pathname === '/market')} data-id="element-2891" data-mp="3fzqym3zhm2xq">
              <LayoutGridIcon aria-hidden className={cn('h-5 w-5', pathname === '/market' ? 'text-brand-700' : 'text-ink-subtle')} data-id="element-2892" data-mp="3g1k3peugcf3m" />
              Overview
            </Link>
          </li>
          {marketCategories.map(category => {
          const Icon = CATEGORY_ICONS[category.id];
          const active = pathname === category.to;
          return <li key={category.id} data-id="element-2893" data-mp="1x0t1hh5wl16t">
                <Link to={category.to} className={item(active)} data-id="element-2894" data-mp="1x1ucxmqtzpp2">
                  <Icon aria-hidden className={cn('h-5 w-5', active ? 'text-brand-700' : 'text-ink-subtle')} data-id="element-2895" data-mp="21zw4yx68izco" />
                  <span className="truncate" data-id="element-2896" data-mp="1naq0atomogxe">{category.label}</span>
                </Link>
              </li>;
        })}
        </ul>
      </div>

      <div data-id="element-2897" data-mp="1ea1ugm9e1mvl">
        <p className="px-3 text-caption font-semibold uppercase tracking-wide text-ink-subtle" data-id="element-2898" data-mp="1e9a2dlf027a2">
          Activity
        </p>
        <ul className="mt-2 space-y-0.5" data-id="element-2899" data-mp="1japlv91j45qc">
          {ACTIVITY.map(entry => {
          const Icon = entry.icon;
          return <li key={entry.label} data-id="element-2900" data-mp="19aysjaopfwru">
                <Link to={entry.to} className={item(false)} data-id="element-2901" data-mp="19c02fbtzid7z">
                  <Icon aria-hidden className="h-5 w-5 text-ink-subtle" data-id="element-2902" data-mp="2ypn1f1y36wl4" />
                  {entry.label}
                </Link>
              </li>;
        })}
        </ul>
      </div>

      <div className="rounded-card border border-line bg-canvas px-4 py-4" data-id="element-2903" data-mp="s1mo7bpioa1t">
        <p className="text-body-sm font-semibold text-ink" data-id="element-2904" data-mp="rzjou12h54kf">Sell or offer something</p>
        <p className="mt-1.5 text-caption leading-5 text-ink-muted" data-id="element-2905" data-mp="n0qa65bgb7io">
          Students, vendors, landlords and providers all sell through the same Campuzon account.
        </p>
        <Link to="/market/sell" className="mt-3.5 inline-flex min-h-touch w-full items-center justify-center rounded-lg border border-brand-700 bg-brand-700 px-3 text-body-sm font-medium text-white transition-colors duration-150 ease-out hover:border-brand-800 hover:bg-brand-800 hover:text-white" data-id="element-2906" data-mp="x07h0q2fvrg8">
          Become a provider
        </Link>
      </div>
    </nav>;
}